import axios from "axios";
//import { getUuid } from "./helpers";
import errorNotification from "./api-error";




export default class Api {
    private static BASE_PATH = process.env?.REACT_APP_UIP_API_URL;
    private static LOCAL_HOST = "http://nycnbk148713.noam.corp.frk.com";
    private static getApiUrl(url : any) {
        if (url.startsWith(this.LOCAL_HOST)) {
            return url;
        }
        if (this.BASE_PATH) {
            return this.BASE_PATH + url;
        }
        return url;
    }

    /*private static makeHeaders(headers : any) {
        const targetUser = Settings.getSettings()?.app_settings?.admin?.portal?.targetUser;
        const ret = {
            authorization: `Bearer ${this.accessToken}`,
            "request-id": getUuid(),
            ...headers,
        };

        if (targetUser) ret["target-email"] = targetUser;

        return ret;
    }
    */
    public static apiFailed(error: any, customErrorMsg?: string) {

        const statusCode = error?.response?.status || 500;
        const errMessage = customErrorMsg || error?.response?.data?.message;
        const errorInfo = {
            type: "error",
            text: "Something went wrong.",
            open: true,
        };
        switch (statusCode) {
            case 400:
                errorInfo.text = `${statusCode} :` + (error?.response?.data?.message || "Bad request");
                break;
            case 422:
                errorInfo.text = `${statusCode} :` + (error?.response?.data?.message || "Bad request");
                break;
            case 401:
                errorInfo.text = `${statusCode}: Unauthorized`;
                break;
            case 403:
                errorInfo.text = error?.response?.data?.message || `${statusCode}: Forbidden`;
                break;
            case 404:
                errorInfo.text = errMessage || `${statusCode}: Not found`;
                break;
            case 409:
                // For a 409 Conflict, resolve the promise and pass the response back
                return Promise.resolve(error?.response); // This ensures the caller gets the response
            case 431:
                errorInfo.text = errMessage || `${statusCode}: Request Header Fields Too Large`;
                break;
            case 500:
                errorInfo.text = errMessage || `${statusCode}: Internal server error`;
                break;
            case 502:
                errorInfo.text = `${statusCode}: Bad gateway`;
                break;
            case 503:
                errorInfo.text = `${statusCode}: Service unavailable`;
                break;
        }
        localStorage.setItem("errorMsg", error);
        errorNotification.next(errorInfo);
        const message = `${error?.config?.method?.toUpperCase()}:${error?.config?.url}, Response: ${errorInfo.text}`;
        const payload = {
            error: message,
        };
        //Api.logToLoggerService(payload);
        throw error;
    }

    private static post(url: string, body: any, headers: any = {}, params: any = {}, catchError = true, extractDataFromResp = true) {
        const call = axios
        .post(this.getApiUrl(url), body, {
            //headers: this.makeHeaders(headers),
            params,
        })
        .then((resp) => (extractDataFromResp ? resp.data : resp));
    if (catchError) return call.catch(this.apiFailed);
    return call;
}
private static makeHeaders(headers: any) {
    const accessToken = localStorage.getItem("accessToken");
    const ret = {
        authorization: `Bearer ${accessToken || ""}`,
        ...headers,
    };


    return ret;
}
private static get(url: string ,headers: any = {}, params: any = {}, responseType: any = "json", catchError = true) {
    const call = axios
        .get(this.getApiUrl(url), {
            responseType,
            headers: this.makeHeaders(headers),
            params,
        })
        .then((resp) => resp.data);

    if (catchError) return call.catch(this.apiFailed);
    return call;
}



public static handleTokenValidation() {
    
    return this.get(`/api/goe-api/logininfo`);
}

public static handleLogin = (email: string, passowrd: string, csrf_token: string)=>{
    if(!email || !passowrd || !csrf_token){
        const error ={AuthenticationResult: {ErrorDescription : "Please enter correct details"} };
        return error;
    }
    let body = {
        "email": email,
   "password": passowrd,
   "csrf_token": csrf_token
    };
    return  this.post(`/api/goe-api/signin`, body);


}

public static getCSRFToken = ()=>{
    
    return  this.get(`/api/goe-api/csrf_token`);


}

public static getGoeClients(body:any) {
    return this.get("/api/goe/getLatestDraft");
}

}